import React from 'react';
import { Card, CardContent, Box, Typography, Grid } from '@mui/material';
import { Shield as ShieldIcon } from '@mui/icons-material';
import { formatPercentage } from './utils';

/**
 * ContentCheckResultsCard Component
 *
 * Displays content check results for a version.
 *
 * @param {Object} props
 * @param {Object} props.selectedVersion - Selected version data
 */
function ContentCheckResultsCard({ selectedVersion }) {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <ShieldIcon color="primary" sx={{ mr: 1 }} />
          <Typography variant="h6">Content Check Results</Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Total Content Checks
            </Typography>
            <Typography variant="h6">
              {selectedVersion.total_content_checks || 0}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Average Risk Score
            </Typography>
            <Typography variant="h6">
              {selectedVersion.avg_risk_score !== null &&
              selectedVersion.avg_risk_score !== undefined
                ? selectedVersion.avg_risk_score.toFixed(2)
                : 'N/A'}
            </Typography>
          </Grid>
          {selectedVersion.total_violations !== undefined && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="body2" color="text.secondary">
                Total Violations
              </Typography>
              <Typography variant="h6">
                {selectedVersion.total_violations || 0}
              </Typography>
            </Grid>
          )}
          {selectedVersion.total_critical_violations !== undefined && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="body2" color="text.secondary">
                Critical Violations
              </Typography>
              <Typography variant="h6" color="error.main">
                {selectedVersion.total_critical_violations || 0}
              </Typography>
            </Grid>
          )}
          {selectedVersion.anonymization_rate_percentage !== undefined && (
            <Grid size={{ xs: 12, sm: 6 }}>
              <Typography variant="body2" color="text.secondary">
                Anonymization Rate
              </Typography>
              <Typography variant="h6">
                {formatPercentage(
                  selectedVersion.anonymization_rate_percentage
                )}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ContentCheckResultsCard;
